import {Application} from "stimulus"
import {definitionsFromContext} from "stimulus/webpack-helpers"


const application = Application.start()
// Configure Stimulus development experience
application.debug = true

const context = require.context("controllers", true, /\.js$/)
const contextComponents = require.context("../../components", true, /_controller\.js$/)
window.test = definitionsFromContext(contextComponents)
application.load(
    definitionsFromContext(contextComponents).concat(
        definitionsFromContext(context)
    )
)

window.Stimulus = application

